import { RouteRecordRaw } from "vue-router";

export const routes: Array<RouteRecordRaw> = [
  {
    path: "/",
    redirect: "/asLeadsPortal",
  },
  {
    path: "/login",
    name: "login",
    component: () =>
      import(/* webpackChunkName: "login" */ "../views/login/index.vue"),
    meta: {
      requiresAuth: false,
    },
  },
  {
    path: "/asLeadsPortal",
    name: "asLeadsPortal",
    component: () =>
      import(
        /* webpackChunkName: "asLeadsPortal" */ "@/views/asLeadsPortal/asLeadsPortal.vue"
      ),
    meta: {
      title: "售后线索平台",
      requiresAuth: false,
    },
  },
  {
    path: "/asLeads",
    name: "asLeads",
    component: () =>
      import(/* webpackChunkName: "asLeads" */ "@/views/asLeads/asLeads.vue"),
    meta: {
      title: "售后线索详情",
      requiresAuth: true,
    },
  },
];
